// @deprecated Use the SectionRegistry from 'ai-rendering-library/sections/formatters/registry' instead.
// This module is kept only for backwards compatibility with external consumers (academy-ai-assistant).

import { gate } from 'hub-http/gates';
import Raven from 'raven-js';
import { Suspense, lazy } from 'react';
import { ArtifactCardResponseSectionTypename, ComposableCardResponseSectionTypename, HighchartsChartResponseSectionTypename, ImageGridResponseSectionTypename, InlineAcademyVideoResponseSectionTypename, MeetingPrepActionDataResponseSectionTypename, MeetingRecapActionDataResponseSectionTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import ArtifactCardSectionFormatter from '../../../sections/formatters/ArtifactCardSectionFormatter';
import ComposableCardSectionFormatter from '../../../sections/formatters/composable-card/ComposableCardSectionFormatter';
import ImageGridSectionFormatter from '../../../sections/formatters/ImageGridSectionFormatter';
import MeetingRecapActionsSectionFormatter from '../../../sections/formatters/MeetingRecapActionsSectionFormatter';
import InlineAcademyVideo from './InlineAcademyVideo';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyHighchartsChartSectionFormatter = /*#__PURE__*/lazy(() => import('../../../sections/formatters/HighchartsChartSectionFormatter'));
export const renderDynamicSection = (container, callbacks, getIsUngated, message) => {
  const {
    responseSection
  } = container;
  switch (responseSection.__typename) {
    case ComposableCardResponseSectionTypename:
      if (getIsUngated !== null && getIsUngated !== void 0 && getIsUngated(gate('BreezeAssistant:Tools:VisualRendering'))) {
        return /*#__PURE__*/_jsx(ComposableCardSectionFormatter, {
          section: responseSection,
          callbacks: callbacks,
          message: message
        });
      }
      return null;
    case HighchartsChartResponseSectionTypename:
      return /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(LazyHighchartsChartSectionFormatter, {
          section: responseSection
        })
      });
    case ImageGridResponseSectionTypename:
      return /*#__PURE__*/_jsx(ImageGridSectionFormatter, {
        section: responseSection,
        callbacks: callbacks
      });
    case InlineAcademyVideoResponseSectionTypename:
      return /*#__PURE__*/_jsx(InlineAcademyVideo, {
        section: responseSection
      });
    case MeetingRecapActionDataResponseSectionTypename:
      if (getIsUngated !== null && getIsUngated !== void 0 && getIsUngated(gate('BreezeAssistant:MeetingActionData'))) {
        return /*#__PURE__*/_jsx(MeetingRecapActionsSectionFormatter, {
          section: responseSection,
          callbacks: callbacks
        });
      }
      return null;
    case MeetingPrepActionDataResponseSectionTypename:
      return null;
    case ArtifactCardResponseSectionTypename:
      return /*#__PURE__*/_jsx(ArtifactCardSectionFormatter, {
        section: responseSection,
        callbacks: callbacks
      });
    default:
      Raven.captureException(new Error(`Unsupported dynamic section type: ${responseSection.__typename}`), {
        extra: {
          component: 'renderDynamicSection'
        }
      });
      return null;
  }
};